import { all, fork, put, takeEvery, call } from "redux-saga/effects";
import { SagaIterator } from "@redux-saga/core";

// constants
import { DevicesActionTypes } from "./constants";
import { getDevices, DeviceApiResponseSuccess, DeviceApiResponseError } from "./actions";
import { addDeviceApi, deleteDeviceApi, getDevicesApi, updateDeviceApi, updateDeviceAvailabilityApi } from "../../helpers/api/devices";
import { MAX_ITEMS_PER_PAGE } from "../../helpers/api/apiCore";

const params: any = {
  page: 1,
  limit: MAX_ITEMS_PER_PAGE,
};

// Fetch devices saga
function* getDevicesSaga({ payload }: any): SagaIterator {
  try {
    const response = yield call(getDevicesApi, payload);
    const devices = response?.data?.data;

    yield put(DeviceApiResponseSuccess(DevicesActionTypes.GET_DEVICES, devices));
  } catch (error: any) {
    yield put(DeviceApiResponseError(DevicesActionTypes.GET_DEVICES, error));
  }
}

// Update device saga
function* updateDeviceSaga({
  payload: { id, unique_id, device_id, name, location_id, corporate_id, total_powerbanks, available_powerbanks, status },
}: any): SagaIterator {
  try {
    const response = yield call(updateDeviceApi, {
      id,
      unique_id,
      device_id,
      name,
      location_id,
      corporate_id,
      total_powerbanks,
      available_powerbanks,
      status,
    });
    const message = response?.data?.message;

    yield put(DeviceApiResponseSuccess(DevicesActionTypes.UPDATE_DEVICES, message));
    yield put(getDevices(params));
  } catch (error: any) {
    yield put(DeviceApiResponseError(DevicesActionTypes.UPDATE_DEVICES, error));
  }
}

// Add new device saga
function* addDeviceSaga({
  payload: { unique_id, device_id, name, location_id, corporate_id, total_powerbanks, available_powerbanks },
}: any): SagaIterator {
  try {
    const response = yield call(addDeviceApi, { unique_id, device_id, name, location_id, corporate_id, total_powerbanks, available_powerbanks });
    const message = response?.data?.message;

    yield put(DeviceApiResponseSuccess(DevicesActionTypes.ADD_DEVICES, message));
    yield put(getDevices(params));
  } catch (error: any) {
    yield put(DeviceApiResponseError(DevicesActionTypes.ADD_DEVICES, error));
  }
}

// Delete device saga
function* deleteDeviceSaga({ payload: { id } }: any): SagaIterator {
  try {
    const response = yield call(deleteDeviceApi, { id });
    const message = response?.data?.message;

    yield put(DeviceApiResponseSuccess(DevicesActionTypes.DELETE_DEVICES, message));
    yield put(getDevices(params));
  } catch (error: any) {
    yield put(DeviceApiResponseError(DevicesActionTypes.DELETE_DEVICES, error));
  }
}

// Update device availability saga
function* updateAvailabilitySaga({ payload: { id, available_powerbanks } }: any): SagaIterator {
  try {
    const response = yield call(updateDeviceAvailabilityApi, { id, available_powerbanks });
    const message = response?.data?.message;

    yield put(DeviceApiResponseSuccess(DevicesActionTypes.UPDATE_DEVICES_AVAILABILTY, message));
    yield put(getDevices(params));
  } catch (error: any) {
    yield put(DeviceApiResponseError(DevicesActionTypes.UPDATE_DEVICES_AVAILABILTY, error));
  }
}

// Watchers
export function* watchGetDevices() {
  yield takeEvery(DevicesActionTypes.GET_DEVICES, getDevicesSaga);
}

export function* watchUpdateDevice() {
  yield takeEvery(DevicesActionTypes.UPDATE_DEVICES, updateDeviceSaga);
}

export function* watchAddDevice() {
  yield takeEvery(DevicesActionTypes.ADD_DEVICES, addDeviceSaga);
}

export function* watchDeleteDevice() {
  yield takeEvery(DevicesActionTypes.DELETE_DEVICES, deleteDeviceSaga);
}

export function* watchUpdateAvailability() {
  yield takeEvery(DevicesActionTypes.UPDATE_DEVICES_AVAILABILTY, updateAvailabilitySaga);
}

// Root saga
function* DevicesSaga() {
  yield all([fork(watchGetDevices), fork(watchUpdateDevice), fork(watchAddDevice), fork(watchDeleteDevice), fork(watchUpdateAvailability)]);
}

export default DevicesSaga;
